module.exports = __webpack_public_path__ + "img/reco3.e9c7b556.jpg";